module.exports = __webpack_public_path__ + "static/img/main_supply_bg.282b536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/main_supply_bg.png
// module id = o+yc
// module chunks = 44